import React from "react"
import styled, { keyframes } from "styled-components"
import HeroSection from "../../components/HeroSection/HeroSection"
import Processus from "../../components/Processus/Processus.jsx"
import CardServices from "../../components/CardServices/CardServices.jsx"
import AvisMario from "../../assets/images/avis-mario.png"
import CardListDetails from "../../components/Card/CardListDetails.jsx"
import {
    MainContainer,
    CenterTitle,
    Title,
} from "../../utils/style/elements.tsx"
import colors from "../../utils/style/colors.tsx"
import { useScrollReveal } from "../../utils/hooks/useScrollReveal"

// Animation de fade in + slide up
const fadeInUp = keyframes`
    from {
        opacity: 0;
        transform: translateY(50px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`

// Wrapper animé
const AnimatedSection = styled.div`
    opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
    animation: ${({ $isVisible }) => ($isVisible ? fadeInUp : 'none')} 0.8s ease-out;
    animation-delay: ${({ $delay }) => $delay || '0s'};
    animation-fill-mode: both;
`

const SectionCardServices = styled.div`
    margin-bottom: 5vw;
    text-align: center;
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 110%;
    margin-left: -5%;
`

const CardServiceList= styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 12px;

    @media (max-width: 1000px) {
        flex-direction: column;
        align-items: center;
    }
`

const SectionProcessus = styled.div`
    margin-bottom: 5vw;
    text-align: center;
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 110%;
    margin-left: -5%;
`

const ContainerAvis = styled.div`
    width: 100%;
`

const ImgAvis = styled.img`
    width: 70%;

    @media (max-width: 768px) {
        width: 90%;
    }
`

const SectionOffres = styled.div``

const SectionOffresCard = styled.div`
    width: 100%;
    overflow: hidden;
    transition: max-height 0.5s ease-in-out;
    display: flex;
    flex-direction: column;
`

const SectionOffresDesign = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-around;

    @media (max-width: 1020px) {
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        justify-items: center;
    }
`

const SectionOffresSite = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-around;

    @media (max-width: 1020px) {
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        justify-items: center;
    }
`

const StyledCenterTitle = styled(CenterTitle)`
    display: flex;
    justify-content: center;
    color: ${colors.h1_red};
`

function Service() {
    const [refCardServices, isVisibleCardServices] = useScrollReveal({ once: true, threshold: 0.2 })
    const [refProcessus, isVisibleProcessus] = useScrollReveal({ once: true, threshold: 0.2 })
    const [refOffres, isVisibleOffres] = useScrollReveal({ once: true, threshold: 0.2 })
    const [refAvis, isVisibleAvis] = useScrollReveal({ once: true, threshold: 0.2 })

    return (
        <React.StrictMode>
            <HeroSection page="services" />
            <MainContainer>
                <AnimatedSection ref={refCardServices} $isVisible={isVisibleCardServices}>
                    <SectionCardServices>
                        <CenterTitle>
                            <Title>Mes services</Title>
                        </CenterTitle>
                        <CardServiceList>
                            <CardServices page="design" />
                            <CardServices page="site" />
                            <CardServices page="projet" />
                        </CardServiceList>
                    </SectionCardServices>
                </AnimatedSection>

                <AnimatedSection ref={refProcessus} $isVisible={isVisibleProcessus}>
                    <SectionProcessus>
                        <CenterTitle>
                            <Title>Processus du service</Title>
                        </CenterTitle>
                        <Processus />
                    </SectionProcessus>
                </AnimatedSection>

                <SectionOffres id="lesOffres">
                    <AnimatedSection $isVisible={isVisibleOffres} $delay="0s">
                        <StyledCenterTitle>
                            <Title>Les offres</Title>
                        </StyledCenterTitle>
                    </AnimatedSection>

                    <SectionOffresCard ref={refOffres}>
                        {/* Design apparaît en premier */}
                        <AnimatedSection $isVisible={isVisibleOffres} $delay="0s">
                            <SectionOffresDesign id="lesDesign">
                                <CardListDetails
                                    color={colors.light_pink}
                                    service="design"
                                />
                            </SectionOffresDesign>
                        </AnimatedSection>
                        
                        <AnimatedSection $isVisible={isVisibleOffres} $delay="1s">
                            <SectionOffresSite id="lesSites">
                                <CardListDetails
                                    color={colors.pink}
                                    service="site"
                                />
                            </SectionOffresSite>
                        </AnimatedSection>
                    </SectionOffresCard>
                </SectionOffres>

                <AnimatedSection ref={refAvis} $isVisible={isVisibleAvis}>
                    <SectionProcessus>
                        <CenterTitle>
                            <Title>Avis</Title>
                        </CenterTitle>
                        <ContainerAvis>
                            <ImgAvis src={AvisMario} alt="Avis Mario Chabot" />
                        </ContainerAvis>
                    </SectionProcessus>
                </AnimatedSection>
            </MainContainer>
        </React.StrictMode>
    )
}

export default Service